module.exports = __webpack_public_path__ + "img/banker-gold_1248.cab90eb3.png";